import { ProductPrice, useProductOptions } from '@shopify/hydrogen'
import { useContext, useEffect, useRef } from 'react'
import styles from '../../assets/scss/components/products/product-summary.module.scss'
import { useI18n } from '../i18n.client'
import { ProductButton } from './product-button.client'
import { ProductLayoutContext } from './product-layout-provider.client'

export const ProductSummary: React.FC = () => {
  const [i18n] = useI18n()
  const ref = useRef<HTMLDivElement>(null)
  const { product, productDetailsRef, setProductSummaryHeight } = useContext(ProductLayoutContext)
  const { options, selectedVariant } = useProductOptions()
  const isOutOfStock = !selectedVariant?.availableForSale ?? false
  const hasOption =
    !isOutOfStock && options && options[0] && options[0].values && options[0].values.length > 1 && options[0].name

  useEffect(() => {
    if (ref.current) {
      setProductSummaryHeight(ref.current.getBoundingClientRect().height)
    }
  }, [ref])

  return (
    <div className={styles.summary} ref={ref}>
      <div className={styles.info}>
        <div className={styles.title}>{product.title}</div>
        {(!product.priceOnAsking || product.priceOnAsking.value === 'false') && (
          <div className={styles.priceContainer}>
            <ProductPrice data={product} variantId={selectedVariant?.id} />
            <ProductPrice
              className={styles.discounted}
              data={product}
              priceType="compareAt"
              variantId={selectedVariant?.id}
            />
          </div>
        )}
      </div>
      <div className={styles.actions}>
        <button
          className={styles.infoButton}
          onClick={() => productDetailsRef?.current?.scrollIntoView({ behavior: 'smooth' })}>
          {i18n.translate('info')} +
        </button>
        {hasOption ? (
          <button
            className={styles.buyButton}
            onClick={() => productDetailsRef?.current?.scrollIntoView({ behavior: 'smooth' })}>
            {i18n.translate('select-option', { option: hasOption })}
          </button>
        ) : (
          <ProductButton className={styles.buyButton} />
        )}
      </div>
    </div>
  )
}
